import { render, staticRenderFns } from "./UiInputWrapper.vue?vue&type=template&id=ffccc6c4"
import script from "./UiInputWrapper.vue?vue&type=script&lang=js"
export * from "./UiInputWrapper.vue?vue&type=script&lang=js"
import style0 from "./UiInputWrapper.vue?vue&type=style&index=0&id=ffccc6c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports